<script>
  import DashboardTitle from "../../../../components/dashboard/DashboardTitle.svelte";
  import TaskChart from "./TaskChart.svelte";
  export let id;
  export let boxTitle;
  export let nTodo;
  export let nInProgress;
  export let nDone;
  //export let link = "";
  //export let personal = false;

  let exists = true;

  /*
  if (link === "" || link === null || link === undefined) {
    link = "https://tasks.office.com/labit.es/es-ES/Home/Planner/#/planhub";
    if (personal) {
      exists = false;
    }
  }
  */

</script>
<div class="dashboardContainer">
  <DashboardTitle title={boxTitle} numEvents={nTodo + nInProgress + nDone} />

  <!-- {#if !exists}
    <div class="messageContainer">
      <span>No pending tasks.</span>
      <span
        >You can manage your personal tasks by creating a Planner hub with
        your Outlook name.</span
      >
      <span>Example: support@labit.es -> support</span>
    </div>
  {:else} -->
    <div class="dashboardBody">
      <div class="taskChartContainer">
        <TaskChart
          {id}
          green={nDone}
          gray={nTodo}
          blue={nInProgress}
          greenLabel="Done"
          grayLabel="To Do"
          blueLabel="In Progress"
        />
      </div>
      <div class="taskCharLegend">
        <div class="typeContainer">
          <div class="pointerToDo" />
          <span class="status">To do</span><span><b>{nTodo}</b></span>
        </div>
        <div class="typeContainer">
          <div class="pointerInProgress" />
          <span class="status">In progress</span><span
            ><b>{nInProgress}</b></span
          >
        </div>
        <div class="typeContainer">
          <div class="pointerDone" />
          <span class="status">Done</span><span><b>{nDone}</b></span>
        </div>
      </div>
    </div>
</div>

<style>
  div.dashboardContainer {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }

  div.dashboardBody,
  .plannerLink {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 85%;
    align-items: center;
    justify-content: center;
  }

  .plannerLink {
    cursor: pointer;
  }

  div.taskChartContainer {
    width: 190px;
    height: 190px;
  }

  div.typeContainer {
    display: flex;
    flex-direction: column;
    margin: 10px;
  }

  div.pointerToDo,
  div.pointerDone,
  div.pointerInProgress {
    width: 15px;
    height: 15px;
    border-radius: 50% !important;
    margin-right: 10px;
  }

  div.pointerInProgress {
    background-color: #327eaa;
  }

  div.pointerToDo {
    background-color: #605e5c;
  }

  div.pointerDone {
    background-color: #418040;
  }

  div.taskCharLegend {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }

  div.typeContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  span.status {
    margin-right: 10px;
  }

  .messageContainer {
    padding: 40px;
    display: flex;
    flex-direction: column;
  }

  .messageContainer span {
    margin: 10px 0px;
  }
</style>
